import React from "react";

import { FormControl } from "lib/components/index";
import st from "lib/utils/index";
import { ProductScheduleSlotDecorator } from "lib/decorators/index";

export const handleSlotTimePropChange = (slot, prop, value) => {
  let newSlot = slot;
  // When setting start_date and end_date is empty, set it as the end_date as well
  if (prop === "start_date" && value && !slot.end_date) {
    newSlot = new ProductScheduleSlotDecorator({
      ...slot,
      [prop]: value,
      end_date: value,
    });
    // When setting start_time and end_time is empty, set it as the end_time as well
  } else if (prop === "start_time" && value && slot.start_date && slot.start_date === slot.end_date) {
    const new_starts_at_moment = new ProductScheduleSlotDecorator({
      ...slot,
      [prop]: value,
      includes_time: true,
    }).starts_at_moment;
    newSlot = new ProductScheduleSlotDecorator({
      ...slot,
      starts_at: new_starts_at_moment.format(moment.RUBY_DATETIME_FORMAT),
      ends_at: new_starts_at_moment.add(1, "hour").format(moment.RUBY_DATETIME_FORMAT),
      includes_time: true,
    });
    // When changing the start_date while end_date is present, move the end_date by x days just as start_date has been moved
  } else if (prop === "start_date" && value && slot.start_date && slot.end_date) {
    newSlot = new ProductScheduleSlotDecorator({
      ...slot,
      [prop]: value,
    });
    const oldDaysDuration = slot.end_date_moment.diff(slot.start_date_moment, "days");
    const newEndDateMoment = newSlot.start_date_moment.add(oldDaysDuration, "days");
    newSlot = new ProductScheduleSlotDecorator({
      ...newSlot,
      end_date: newEndDateMoment.format(moment.RUBY_DATE_FORMAT),
    });
    // When changing the start_time while end_time is present, move the end_time by x days just as start_time has been moved
  } else if (prop === "start_time" && value && slot.start_time && slot.end_time) {
    newSlot = new ProductScheduleSlotDecorator({
      ...slot,
      [prop]: value,
    });
    const oldTimeDuration = slot.ends_at_moment.diff(slot.starts_at_moment, "seconds");
    const newEndsAtMoment = newSlot.starts_at_moment.add(oldTimeDuration, "seconds");
    newSlot = new ProductScheduleSlotDecorator({
      ...newSlot,
      ends_at: newEndsAtMoment.format(moment.RUBY_DATETIME_FORMAT),
    });
    // When clearing out start_time/end_time, remove both times
  } else if ((prop === "start_time" || prop === "end_time") && !value) {
    newSlot = new ProductScheduleSlotDecorator({
      ...slot,
      start_time: null,
      end_time: null,
    });
  } else {
    newSlot = new ProductScheduleSlotDecorator({
      ...slot,
      [prop]: value,
    });
  }
  return newSlot;
};

export default class SlotTimeFormSection extends React.PureComponent {
  handleSlotPropChange(prop, value) {
    const { value: slot, onChange } = this.props;
    const newSlot = handleSlotTimePropChange(slot, prop, value);
    onChange(newSlot);
  }

  render() {
    const { readOnly, name, errors, value: slot, onBlur } = this.props;
    return (
      <div className="ui fields inline">
        <FormControl.DateFormGroup
          {...FormControl.addProps(`${name}.start_date`, { errors })}
          value={slot.start_date}
          onBlur={onBlur}
          onChange={this.handleSlotPropChange.bind(this, "start_date")}
          required
          placeholder={I18n.t("base.from")}
          readOnly={readOnly}
        />
        <FormControl.TimeFormGroup
          {...FormControl.addProps(`${name}.start_time`, { errors })}
          value={slot.start_time}
          onBlur={onBlur}
          onChange={this.handleSlotPropChange.bind(this, "start_time")}
          readOnly={readOnly}
        />
        <span className="u-paddingRight">&rarr;</span>
        <FormControl.DateFormGroup
          {...FormControl.addProps(`${name}.end_date`, { errors })}
          value={slot.end_date}
          onBlur={onBlur}
          onChange={this.handleSlotPropChange.bind(this, "end_date")}
          required
          placeholder={I18n.t("base.to")}
          min={slot.start_date}
          readOnly={readOnly}
          disabled={!slot.start_date}
        />
        <FormControl.TimeFormGroup
          {...FormControl.addProps(`${name}.end_time`, { errors })}
          value={slot.end_time}
          onBlur={onBlur}
          onChange={this.handleSlotPropChange.bind(this, "end_time")}
          min={slot.end_date && slot.start_date === slot.end_date ? slot.start_time : undefined}
          readOnly={readOnly}
          disabled={!slot.start_date}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/StepAvailability/SlotTimeFormSection.jsx